import { render } from "./CheckIcon.vue?vue&type=template&id=f843fd3a"
const script = {}
script.render = render

export default script